import { render, staticRenderFns } from "./answerList.vue?vue&type=template&id=fa01e142"
import script from "./answerList.vue?vue&type=script&lang=js"
export * from "./answerList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports